export const featureFlags = {
  CA_EXPANSION_CODE: 'sc_194788',
  TOYOTA_HIDE_RENTERS_ACCOUNT_CTA: 'sc_209226',
};
